// Subset of HP.Framework ApplicationStatus values the cockpit needs to recognise.
export const ApplicationStatus = {
  Interview: 300,
  SecondInterview: 310,
  ThirdInterview: 320,
  PhoneInterview: 350,
  VideoInterview: 351,
  Denied: 900,
  ProvisionallyDenied: 910,
  DeniedByCandidate: 950
};

export default { ApplicationStatus };
